import { render, staticRenderFns } from "./knowledgeGraph.vue?vue&type=template&id=0b4d6b09&scoped=true&"
import script from "./knowledgeGraph.vue?vue&type=script&lang=js&"
export * from "./knowledgeGraph.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeGraph.vue?vue&type=style&index=0&id=0b4d6b09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d6b09",
  null
  
)

export default component.exports